import * as React from "react";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import { useDispatch } from "react-redux";
import {
  REMOVE_EXTRA_INGREDIENT,
  TOGGLE_NEED_INGREDIENT,
} from "../constants/reducerEvents";

export default function Ingredient({
  name,
  checked,
  onClick,
  calculated = null,
  multiplier = 1,
}) {
  const [localCheck, setLocalCheck] = React.useState(false);
  const clicked = () => {
    if (checked === undefined) {
      setLocalCheck(!localCheck);
    } else {
      onClick();
    }
  };
  const getCalculated = (ing) => {
    return (
      <div>
        <div style={{ display: "flex" }}>
          {ing.hasOwnProperty("quantity") && (
            <div style={{ paddingRight: "3px" }}>
              {ing.quantity * multiplier}
            </div>
          )}
          {ing.hasOwnProperty("measure") && (
            <div style={{ paddingRight: "3px" }}>{ing.measure?.label}</div>
          )}
          {ing.hasOwnProperty("food") && <div>{ing.food.label}</div>}
        </div>

        {/* <img src={ing.food.image} width={50} /> */}
      </div>
    );
  };
  return (
    <div>
      <FormControlLabel
        control={
          <Checkbox
            checked={checked === undefined ? localCheck : checked}
            onChange={clicked}
          />
        }
        label={name}
      />
      {/* {calculated && calculated.map((c) => getCalculated(c))} */}
    </div>
  );
}
